import React, { Children, Fragment } from 'react';
import { motion } from 'framer-motion';
const tomes = [{
  num: 1,
  color: '#22c55e',
  title: 'Fundamentos y Metodología',
  desc: '18 secuencias didácticas · Framework de clase · Planillas y dinámicas'
}, {
  num: 2,
  color: '#eab308',
  title: 'Laboratorio de Técnica',
  desc: '40 ejercicios progresivos en 5 categorías · 4 niveles cada uno'
}, {
  num: 3,
  color: '#f97316',
  title: 'Musicalidad en el Salón',
  desc: '8 orquestas fundamentales · Sistema de 3 capas · 15 actividades'
}, {
  num: 4,
  color: '#ef4444',
  title: 'Retención y Motivación',
  desc: '7 causas del abandono · Sistema de 4 Pilares · Semáforo de Retención'
}, {
  num: 5,
  color: '#a855f7',
  title: 'Guiones de Corrección',
  desc: '80+ guiones exactos · Sistema en 5 Niveles · Protocolo grupal e individual'
}, {
  num: 6,
  color: '#C8962E',
  title: 'El Negocio del Profe',
  desc: 'Precios · Captación · Instagram · Plan de negocio anual'
}];
const includes = [{
  icon: '📋',
  text: 'Planificador semanal + clases con objetivo, actividad y cierre'
}, {
  icon: '📝',
  text: 'Evaluaciones, rúbricas y criterios de promoción por nivel'
}, {
  icon: '👤',
  text: 'Fichas de seguimiento por alumno + diplomas imprimibles'
}, {
  icon: '✨',
  text: 'Material original ProfePack® · 100% para el profe argentino'
}];
export function WhatYouGet() {
  return <section className="relative w-full py-16 sm:py-24 px-4 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0a0a 0%, #080808 50%, #0a0a0a 100%)'
  }} data-id="element-329">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(200,150,46,0.03) 0%, transparent 70%)'
    }} data-id="element-330" />

      <div className="relative max-w-2xl mx-auto" data-id="element-331">
        {/* Heading */}
        <motion.div className="text-center mb-12 sm:mb-14" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-332">
          <p className="text-[#C8962E]/60 text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-333">
            TODO INCLUIDO
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-[2.75rem] font-black text-white leading-tight" data-id="element-334">
            Lo que <span className="text-[#C8962E]" data-id="element-335">recibís</span>
          </h2>
        </motion.div>

        {/* 6 Tomos card */}
        <motion.div className="bg-black/50 border border-[#C8962E]/20 rounded-2xl p-5 sm:p-7 mb-4" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-336">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-337">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-[#C8962E]/20" data-id="element-338" />
            <h3 className="text-[#C8962E] text-base sm:text-lg font-black tracking-wide whitespace-nowrap" data-id="element-339">
              💃 LOS 6 TOMOS
            </h3>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-[#C8962E]/20" data-id="element-340" />
          </div>

          <motion.div className="space-y-2" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.06
            }
          }
        }} data-id="element-341">
            {tomes.map(tome => <motion.div key={tome.num} variants={{
            hidden: {
              opacity: 0,
              x: -14
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.35,
                ease: 'easeOut'
              }
            }
          }} className="group flex items-start gap-3 sm:gap-4 rounded-xl px-3.5 sm:px-4 py-3 sm:py-3.5 bg-white/[0.015] hover:bg-white/[0.04] border border-transparent hover:border-white/5 transition-all duration-300" style={{
            borderLeftWidth: 3,
            borderLeftColor: tome.color
          }} data-id="element-342">
                {/* Number badge */}
                <span className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center text-xs sm:text-sm font-black text-white mt-0.5" style={{
              backgroundColor: `${tome.color}20`,
              color: tome.color
            }} data-id="element-343">
                  {tome.num}
                </span>
                <div className="min-w-0" data-id="element-344">
                  <p className="text-white text-sm sm:text-[15px] font-bold leading-snug" data-id="element-345">
                    {tome.title}
                  </p>
                  <p className="text-gray-500 text-xs sm:text-[13px] leading-relaxed mt-0.5 group-hover:text-gray-400 transition-colors duration-300" data-id="element-346">
                    {tome.desc}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>

        {/* Summary stat bar */}
        <motion.div className="flex items-center justify-center gap-4 sm:gap-6 py-5 mb-4 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} data-id="element-347">
          {[{
          val: '+400',
          label: 'páginas'
        }, {
          val: '18',
          label: 'secuencias'
        }, {
          val: '40',
          label: 'ejercicios'
        }, {
          val: '80+',
          label: 'guiones'
        }].map((s, i) => <Fragment key={i} data-id="element-348">
              {i > 0 && <span className="w-px h-6 bg-gray-800" data-id="element-349" />}
              <div data-id="element-350">
                <p className="text-[#C8962E] text-lg sm:text-xl font-black leading-none" data-id="element-351">
                  {s.val}
                </p>
                <p className="text-gray-600 text-[10px] sm:text-xs font-medium uppercase tracking-wider mt-0.5" data-id="element-352">
                  {s.label}
                </p>
              </div>
            </Fragment>)}
        </motion.div>

        {/* Cada tomo incluye */}
        <motion.div className="relative bg-[#C8962E]/[0.03] border border-[#C8962E]/15 rounded-2xl p-5 sm:p-7 overflow-hidden" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-353">
          {/* Gold top accent line */}
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#C8962E]/40 to-transparent" data-id="element-354" />

          {/* Decorative header */}
          <div className="flex items-center justify-center gap-3 mb-6 sm:mb-7" data-id="element-355">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-[#C8962E]/15" data-id="element-356" />
            <h3 className="text-[#C8962E] text-base sm:text-lg font-black tracking-wide whitespace-nowrap" data-id="element-357">
              ✅ Cada tomo incluye
            </h3>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-[#C8962E]/15" data-id="element-358" />
          </div>

          <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-2.5 max-w-xl mx-auto" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.04
            }
          }
        }} data-id="element-359">
            {includes.map((item, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              y: 8
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.3,
                ease: 'easeOut'
              }
            }
          }} className="group flex items-center gap-3 text-left bg-white/[0.02] rounded-lg px-3.5 py-3 hover:bg-white/[0.05] border border-transparent hover:border-[#C8962E]/15 transition-all duration-300" style={{
            borderLeftWidth: 2,
            borderLeftColor: 'transparent'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderLeftColor = 'rgba(200,150,46,0.4)';
          }} onMouseLeave={e => {
            e.currentTarget.style.borderLeftColor = 'transparent';
          }} data-id="element-360">
                <span className="text-base flex-shrink-0 w-8 h-8 rounded-lg bg-[#C8962E]/[0.06] flex items-center justify-center group-hover:bg-[#C8962E]/[0.12] transition-colors duration-300" data-id="element-361">
                  {item.icon}
                </span>
                <span className="text-gray-400 text-[13px] sm:text-sm leading-snug group-hover:text-gray-200 transition-colors duration-300" data-id="element-362">
                  {item.text}
                </span>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}